const constants = {
    bytesInMegabyte: 1000000,
};

export default constants;
